import { FunctionComponent, ReactElement, useEffect, useRef, useState } from "react";
import CoreStrings from "src/_core/strings/strings";
import "./styles.scss";

type ResetPasswordTextInputProps = {
  value: string;
  placeholder: string;
  maxlen?: number;
  onChange: (val: string, clear: boolean) => void;
};

export const ResetPasswordTextInput: FunctionComponent<ResetPasswordTextInputProps> = (props): ReactElement => {
  const { value, placeholder, maxlen = 100, onChange } = props;

  const [focus, setFocus] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div className="reset-password-textInput">
      <div className={`reset-password-textInput__content ${focus ? "focus" : ""} ${value.length > maxlen ? "error" : ""}`}>
        <input
          placeholder={placeholder}
          value={value}
          ref={inputRef}
          onChange={(e) => {
            onChange(e.target.value, false);
          }}
          onFocus={() => {
            setFocus(true);
          }}
          onBlur={() => {
            setFocus(false);
          }}
        />
        {value.length > 0 && (
          <span
            onClick={() => {
              onChange("", true);
            }}
          >
            {CoreStrings.clear}
          </span>
        )}
      </div>
      <div className={`reset-password-textInput__error ${value.length > maxlen ? "error" : ""}`}>
        <span>{`View Name exceeds ${maxlen} characters`}</span>
        <span>{`${value.length}/${maxlen}`}</span>
      </div>
    </div>
  );
};

export default ResetPasswordTextInput;
